/**
 * src/services/api.ts
 */

import { BASE_URL } from './config';

export const request = async (url: string, options: RequestInit = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'API Request failed');
  return data;
};

export const getToken = () => localStorage.getItem('sell_token');

export const fetchProducts = (query = {}) => {
  const params = new URLSearchParams(query as any).toString();
  return request(`/products?${params}`);
};

export const fetchAlgorithm = (id: string) => {
  return request(`/algorithms/${id}`);
};

export const submitOrder = (orderData: any) => {
  const token = getToken();
  return request('/customer/orders', {
    method: 'POST',
    body: JSON.stringify(orderData),
    headers: token ? { 'Authorization': `Bearer ${token}` } : {},
  });
};

export const sendOTP = (phone: string) => {
  return request('/customer/auth/send-otp', {
    method: 'POST',
    body: JSON.stringify({ phone }),
  });
};

export const verifyOTP = async (phone: string, otp: string) => {
  const data = await request('/customer/auth/verify-otp', {
    method: 'POST',
    body: JSON.stringify({ phone, otp }),
  });
  if (data.token) {
    localStorage.setItem('sell_token', data.token);
  }
  return data;
};

export const getMe = () => {
  const token = getToken();
  return request('/customer/auth/me', {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const getMyOrders = () => {
  const token = getToken();
  return request('/customer/orders', {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const updateProfile = (data: { name?: string; email?: string }) => {
  const token = getToken();
  return request('/customer/auth/profile', {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const submitLead = (leadData: any) => {
  const token = getToken();
  return request('/leads', {
    method: 'POST',
    body: JSON.stringify(leadData),
    headers: token ? { 'Authorization': `Bearer ${token}` } : {},
  });
};
